module.exports = __webpack_public_path__ + "img/big_11B03_red.461f73b3.png";